import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import { AdminSession, SubstitutionRequestStatus } from '@airreading/common/data';

interface SessionTeacherDisplayProps {
  session: AdminSession;
}

export const SessionTeacherDisplay = ({ session }: SessionTeacherDisplayProps) => {
  const { mostRecentRequest } = getSessionSubstitutionRequestSummary(session);
  const hasPendingRequest = mostRecentRequest?.status === SubstitutionRequestStatus.pending;
  const { substituteCoach, coach } = session;

  if (hasPendingRequest) {
    return 'Pending substitute teacher';
  }

  const coachToShow = substituteCoach || coach;
  return coachToShow ? <PeopleBadgeList people={[coachToShow]} /> : '-';
};
